import React, { useEffect } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import { Container } from 'react-bootstrap'

import Dashboard from '../pages/breeder/Dashboard'
import Calendar from '../pages/breeder/Calendar'
import EventRegister from '../pages/breeder/EventRegister'
import Animals from '../pages/breeder/Animals'
import AnimalDetails from '../pages/breeder/AnimalDetails'
import EventHistorical from '../pages/breeder/EventHistorical'

import MenuBreeder from '../components/menus/MenuBreeder'
import Sidebar from '../components/menus/Sidebar'
import { useAuth } from '../components/auth/useAuth'
import i18n from 'i18next'
import MenuMovil from '../components/menus/MenuMovil'
import NothingHere from '../pages/error/NothingHere'
import Version from '../version'

const t = i18n.t.bind(i18n)

export default function BreederRouter () {
	const navigate = useNavigate()
	const {clientauth} = useAuth()

	useEffect(() => {
		let token = localStorage.getItem('jwt')

		if (!token) {
			navigate(`/${t("url.auth.login")}`)
		}
	}, [navigate])

	const breederRoutesAlias = {
		"": "dashboard",
		[t("url.breeder.dashboard")]: "dashboard",
		[t("url.breeder.calendar")]: "calendar",
		[t("url.breeder.events")]: "events",
		[`${t("url.breeder.event")}/${t("url.breeder.register")}/:type`]: "event_register",
		[t("url.breeder.animals")]: "animals",
		[`${t("url.breeder.animal")}/:id`]: "animaldetails"
	}

	const getComponentBreeder = (path) => {
		switch (path) {
			case "dashboard": return <Dashboard/>;
			case "calendar": return <Calendar/>;
			case "events": return <EventHistorical/>;
			case "event_register": return <EventRegister />;
			case "animals": return <Animals/>;
			case "animaldetails": return <AnimalDetails/>;
			default: return <NothingHere />;
		}
	}

	return (
		<Container fluid className='d-flex p-0'>
			<Sidebar rol={clientauth?.rol}/>
			<Container fluid className="contenedor">
				<MenuBreeder roles={clientauth?.rol}/>
				<Routes>
					{Object.entries(breederRoutesAlias).map(([alias, path]) => (
						<Route key={alias} path={alias} element={getComponentBreeder(path)} />
					))}
					<Route path="*" element={<NothingHere />}/>
				</Routes>
				<div className='text-center mb-2' style={{paddingBottom: "60px"}}>
					<Version />
				</div>
			</Container>
			<MenuMovil rol={clientauth?.rol}/>
		</Container>
	)
}